import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/component_example',
  component: Layout,
  name: 'componentExample',
  meta: {
    title: '组件示例',
    icon: 'ep:suitcase',
    code: '0102',
  },
  children: [
    {
      path: 'basic',
      name: 'componentExampleBasic',
      component: () => import('@/views/component_basic_example/basic/index.vue'),
      meta: {
        title: '基础组件',
        code: '010201',
      },
    },
    {
      path: 'builtIn',
      name: 'componentExampleBuiltIn',
      meta: {
        title: '内建组件',
        code: '010202',
        popover: true,
      },
      children: [
        {
          path: 'avatar',
          name: 'componentExampleBuiltInAvatar',
          component: () => import('@/views/component_built_in_example/avatar.vue'),
          meta: {
            title: '头像',
            code: '01020201',
          },
        },
        {
          path: 'table',
          name: 'componentWeTable',
          component: () => import('@/views/component_basic_example/table_example/index.vue'),
          meta: {
            title: '表格',
            code: '01020202',
          },
        },
        {
          path: 'map',
          name: 'componentExampleBuiltInMap',
          component: () => import('@/views/component_built_in_example/wemap.vue'),
          meta: {
            title: '地图',
            code: '01020203',
          },
        },
        {
          path: 'qrcode',
          name: 'componentExampleBuiltInQrcode',
          component: () => import('@/views/component_built_in_example/qrcode/index.vue'),
          meta: {
            title: '二维码',
            code: '01020204',
          },
        },
      ],
    },
  ],
}

export default routes
